"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casteldaccia": {
    "daf615c7": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "balate": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7594b942": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "calvario": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbc258f1": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "casuzze": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97179784": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "cutelli": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea962da1": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "furriatu": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83a5fab6": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "montagnola": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2a9def2": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "nutricato": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38f6eee3": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "olivuzza": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b05fe66": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "orestagno": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6d04b015": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "pataio": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc9e71bd": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-villini": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c95d2315": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "saranella": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad6ae8f5": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "sedile": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0753105": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05002a07": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78cd02c6": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "vaniddazza": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eed89c45": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "skipSearch": false
    }],
    "via-naurra": [{
      "hkey": "c45d594e",
      "slug": "casteldaccia",
      "name": "Casteldaccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;